export default "__VITE_ASSET__Bz1iQ2Lp__"